<template>
    <div>
        <h3 style="margin-bottom: 10px;"># 任务进度与奖励记录</h3>
        <el-tabs v-model="activeTab" @tab-click="handleTabChange">
            <el-tab-pane label="全部" name="all" />
            <el-tab-pane label="未完成" name="incomplete" />
            <el-tab-pane label="已完成" name="completed" />
        </el-tabs>
        <div class="taskLogFilters">
            <el-input v-model="searchForm.nickname" clearable placeholder="用户昵称" @keyup.enter.native="handleSearch" />
            <el-input v-if="!userId" v-model="searchForm.userId" clearable placeholder="用户ID"
                @keyup.enter.native="handleSearch" />
            <el-input v-model="searchForm.taskName" clearable placeholder="任务名称" @keyup.enter.native="handleSearch" />
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
        </div>
        <div class="elTableBox">
            <!-- 表格 -->
            <el-table class="columnClassNav" align="center" :data="tableData" v-loading="loading" border>
                <el-table-column fixed type="index" label="序号" align="center" width="50">
                </el-table-column>

                <el-table-column prop="taskId" label="任务ID" align="center">
                </el-table-column>

                <el-table-column prop="userid" label="用户ID" align="center">
                </el-table-column>

                <el-table-column prop="userPicture" label="用户头像" align="center">
                    <template #default="{ row }">
                        <el-image style="width: 50px; height: 50px" :src="row.userPicture" fit="cover"></el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="nickname" label="用户名称" align="center">
                </el-table-column>

                <el-table-column fixed prop="taskName" label="任务名称" align="center">
                </el-table-column>

                <el-table-column prop="taskType" label="任务类型" align="center">
                    <template #default="{ row }">
                        <el-tag type="primary">{{ taskTypeHandel(row.taskType) }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="进度时间" align="center">
                </el-table-column>

                <el-table-column label="任务进度" align="center">
                    <template #default="{ row }">
                        {{ row.progressNumber == null ? '—' : row.progressNumber + '/' + (row.achievementNumber || 1) }}
                    </template>
                </el-table-column>

                <el-table-column label="任务状态" align="center">
                    <template #default="{ row }">
                        <el-tag :type="row.progressNumber >= row.achievementNumber ? 'success' : 'info'">
                            {{ row.achievementNumber && row.progressNumber >= row.achievementNumber ? '已完成' : '未完成' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="taskCycle" label="任务周期" align="center">
                    <template #default="{ row }">
                        <el-tag type="primary">
                            {{ row.taskCycle == 0 ? '每日任务' : row.taskCycle == 1 ? '每周任务' : row.taskCycle == 2 ? '每月任务' :
                                row.taskCycle == 3 ? '每年任务' : '无时限任务' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="奖励状态" align="center">
                    <template #default="{ row }">
                        <el-tag :type="row.status === true || row.status === 1 ? 'success' : 'info'">
                            {{ row.status === true || row.status === 1 ? '已自动发放' : '未发放' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="rewardType" label="实际发放奖励" align="center">
                    <template #default="{ row }">
                        <template v-if="row.status === true || row.status === 1">
                            <span style="margin-right: 5px;">{{ row.rewardQuantity == null ? 0 : row.rewardQuantity }}</span>
                            <span style="color: #F37B1D;">
                                {{ row.rewardType == 0 ? '经验' : row.rewardType == 1 ? '积分' : row.rewardType == 2 ?
                                    '星币' : '未知' }}
                            </span>
                        </template>
                        <span v-else>—</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getTaskLogApi, getTaskLogByUserIdApi } from '@/api/virtual'
export default {
    name: 'taskCenterPage',
    data() {
        return {
            tableData: [],
            loading: false,
            requestSerial: 0,
            activeTab: 'all',
            searchForm: { nickname: '', userId: '', taskName: '' },
            dialogVisible: false,
            dialogTitle: '',
            labelPosition: 'right',
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
            nowFrom: {
                taskType: '',
                taskCycle: '',
                rewardType: '',
                userRewardQuantity: '',
                vipuserRewardQuantity: '',
                taskName: '',
                taskDescribe: ''
            },
            rules: {
                taskName: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' }
                ],
                taskType: [
                    { required: true, message: '请选择任务类型', trigger: 'change' }
                ],
                taskCycle: [
                    { required: true, message: '请选择任务周期', trigger: 'change' }
                ],
                rewardType: [
                    { required: true, message: '请选择奖励类型', trigger: 'change' }
                ],
                userRewardQuantity: [
                    { required: true, message: '请输入普通用户奖励数量', trigger: 'blur' },
                    { type: 'number', message: '奖励数量必须为数字', trigger: 'blur' }
                ],
                vipuserRewardQuantity: [
                    { required: true, message: '请输入VIP用户奖励数量', trigger: 'blur' },
                    { type: 'number', message: '奖励数量必须为数字', trigger: 'blur' }
                ]
            },
            taskTypeMap: {
                0: '发布帖子', 1: '回复帖子', 2: '回复他人评论',
                3: '帖子点赞', 4: '帖子收藏', 5: '帖子转发',
                6: '赠送礼物', 7: '用户充值', 8: '关注用户',
                9: '购买商品', 10: '邀请好友', 11: '每日签到',
                12: '购买会员', 13: '观看广告'
            }
        }
    },
    props: {
        userId: {
            type: Number,
            default: 0
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        taskTypeHandel(type) {
            // 兼容数字/字符串类型的type
            return this.taskTypeMap[Number(type)] || '未知任务类型';
        },
        loadData() {
            const query = {
                ...this.params,
                completionState: this.activeTab,
                nickname: this.searchForm.nickname.trim(),
                taskName: this.searchForm.taskName.trim()
            }
            if (!this.userId && this.searchForm.userId.trim()) {
                query.userId = Number(this.searchForm.userId.trim())
            }
            const serial = ++this.requestSerial
            this.loading = true
            const request = this.userId ? getTaskLogByUserIdApi(this.userId, query) : getTaskLogApi(query)
            request.then(res => {
                if (serial !== this.requestSerial) return
                if (res.code == 200) {
                    this.tableData = res.data.records || []
                    this.total_pages = res.data.total || 0
                } else {
                    this.$message.error(res.msg || '获取列表失败')
                }
            }).catch((err) => {
                if (serial === this.requestSerial) this.$message.error(err ? err : '获取列表失败')
            }).finally(() => {
                if (serial === this.requestSerial) this.loading = false
            })
        },
        handleTabChange(tab) {
            this.activeTab = tab.name
            this.params.pageNum = 1
            this.loadData()
        },
        handleSearch() {
            const userId = this.searchForm.userId.trim()
            if (!this.userId && userId && (!/^[1-9]\d*$/.test(userId) || Number(userId) > 2147483647)) {
                this.$message.warning('请输入有效的用户ID')
                return
            }
            this.params.pageNum = 1
            this.loadData()
        },
        handleReset() {
            this.searchForm = { nickname: '', userId: '', taskName: '' }
            this.params.pageNum = 1
            this.loadData()
        },
        handleCurrentChange(number) {
            this.params.pageNum = number
            this.loadData()
        },
        handleSizeChange(size) {
            this.params.pageSize = size
            this.params.pageNum = 1
            this.loadData()
        },
        // 对话框关闭前的钩子（补充）
        dialogBeforeClose(done) {
            this.$refs.nowFrom.resetFields();
            done();
        }
    }
}
</script>

<style scoped lang="scss">
.taskLogFilters {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;

    .el-input {
        width: 180px;
    }

    .el-button + .el-button {
        margin-left: 0;
    }
}

.elTableBox {
    display: flex;
    width: 100%;
    padding-right: 20px;
}


// 新增：调整单选框的间距，优化显示
::v-deep .el-radio {
    margin-right: 15px;
    margin-bottom: 10px;
}

.formBodyBox {
    display: flex;
    flex-wrap: no-wrap;

    .formLeftBox {
        width: 48%;
        margin-right: 10px;
        border-right: 1px solid #eee;
        padding: 0 15px;

        .iconNavBox {
            .iconfont {
                font-size: 20px;
            }

            .wyqicon-shiming {
                font-size: 30px;
            }

            .wyqicon-shizixing,
            .wyqicon-jifen {
                font-size: 26px;
            }
        }

        .myIdentity {
            text-align: center;
            font-size: 1.3em;
            font-weight: 550;
            color: black;
        }

        .iconBox {
            margin-top: 15px;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            text-align: center;

            div {
                flex: 1;
                margin-right: 15px;
                font-size: 14px;
            }

            .iconSex {
                width: 63px;
                background-color: rgb(233, 232, 232);
                height: 20px;
                border-radius: 16px;
                text-align: center;
                line-height: 20px;
                color: black;
                font-size: 10px;
                font-weight: 550;
            }
        }

        .myIDtwoIcon {
            span {
                height: 30px;
                line-height: 30px;
            }
        }

        .ipSee {
            margin-top: 15px;
            font-size: 12px;
            display: flex;
            color: black;

            span {
                flex: 1
            }
        }

        .myName {
            margin: 20px 0;
            text-align: center;

            .spanOne {
                margin-right: 5vw;
            }

            font-size: 14px;
        }

        .navImageBox {
            text-align: center;
        }

        .el-image {
            border-radius: 50%;
        }

        .myIDtwoIcon {
            display: flex;
            justify-content: space-between;
        }
    }

    .formRightBox {
        width: 70%;
        flex-wrap: wrap;

        .el-input {
            margin-right: 15px;
            width: 125px;
            height: 28px;
            line-height: 28px;
        }

        .titleboxSize {
            display: inline-block;
            margin-right: 7px;
            width: 60px;
            text-align: right;
        }

        .el-form-item {
            margin-top: 23px;
        }
    }
}
</style>
